module.exports = __webpack_public_path__ + "img/yige_logo.597f280d.png";